// extracted by mini-css-extract-plugin
export default {"wrapper":"dQ-z","firstToReview":"eQ-z","productCards":"fQ-z","productCard":"gQ-z","stars":"hQ-z","hidden":"iQ-z"};